import Statement from './Statement';

export default Statement;
